import { API_URL } from './client';

type MessageHandler = (message: any) => void;

class WebSocketService {
    private ws: WebSocket | null = null;
    private messageHandlers: MessageHandler[] = [];
    private reconnectInterval: number = 3000;
    private shouldReconnect: boolean = true;

    connect(token: string) {
        if (this.ws) {
            this.ws.close();
        }

        const wsProtocol = API_URL.startsWith('https') ? 'wss' : 'ws';
        const wsBaseUrl = API_URL.replace(/^https?:\/\//, '');
        const wsUrl = `${wsProtocol}://${wsBaseUrl}/ws?token=${token}`;
        this.ws = new WebSocket(wsUrl);

        this.ws.onopen = () => {
            console.log('WebSocket connected');
        };

        this.ws.onmessage = (event) => {
            try {
                const data = JSON.parse(event.data);
                this.messageHandlers.forEach(handler => handler(data));
            } catch (error) {
                console.error('Failed to parse WebSocket message:', error);
            }
        };

        this.ws.onclose = () => {
            console.log('WebSocket disconnected');
            if (this.shouldReconnect) {
                setTimeout(() => this.connect(token), this.reconnectInterval);
            }
        };

        this.ws.onerror = (error) => {
            console.error('WebSocket error:', error);
        };
    }

    disconnect() {
        this.shouldReconnect = false;
        if (this.ws) {
            this.ws.close();
            this.ws = null;
        }
    }

    onMessage(handler: MessageHandler) {
        this.messageHandlers.push(handler);
        return () => {
            this.messageHandlers = this.messageHandlers.filter(h => h !== handler);
        };
    }
}

export const socketService = new WebSocketService();
